import { textFormatting, view, contentEditable } from '@yola/ws-sdk';

const selectAllText = () => {
  const selection = textFormatting.accessors.getAdvancedSelection();
  const { anchorNode } = selection;
  const closestContentEditableElement = anchorNode.parentElement.closest('[contenteditable]');

  if (!closestContentEditableElement) {
    return;
  }

  const liveDocument = view.accessors.getLiveDocument();
  const range = liveDocument.createRange();
  const firstTextNode = contentEditable.helpers.findFirstTextNode(
    closestContentEditableElement,
    true
  );
  const lastTextNode = contentEditable.helpers.findLastTextNode(
    closestContentEditableElement,
    true
  );

  if (!firstTextNode || !lastTextNode) {
    return;
  }

  range.setStart(firstTextNode, 0);
  range.setEnd(lastTextNode, lastTextNode.length);
  selection.removeAllRanges();
  selection.addRange(range);
  selection.refresh();
};

export default selectAllText;
